import React, { useEffect, useContext, useState } from 'react';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import {Breadcrumb, BreadcrumbItem  } from "react-bootstrap";
import Preloader from "../../components/Preloader/Preloader";
import {Modal, ModalBody, ModalHeader, ModalFooter, Alert  } from "react-bootstrap";
import { Button, Dropdown, Table, ButtonGroup } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import ClientAccountsView from './ClientAccountsView';
import ClientOrdersView from './ClientOrdersView';
import ProcessOrder from './ProcessOrder';
import { Link} from "react-router-dom";
import {RoutesLocal} from '../../routes';
import ClientAddForm from './ClientAddForm';
import AccountsAddForm from './AccountsAddForm';
import InvoicePage from './InvoicePage';

const config = require('../../config.json');

export default function ClientsView() {
  const { validateLogin, alertClose , alertDetails, setAlertDetails, loggedUser} = useContext(ProductContext);
  const [loaded, setLoaded] = useState(false);
  const [clientViewCollapsed, setClientViewCollapsed] = useState(true);
  const [orderViewCollapsed, setOrderViewCollapsed] = useState(true);
  const [processOrderCollapsed, setProcessOrderCollapsed] = useState(true);
  const [clientAddCollapsed, setClientAddCollapsed] = useState(true);
  const [accountAddCollapsed, setAccountAddCollapsed] = useState(true);
  const [clientDetails, setClientDetails]= useState([]);
  const [selectedAccount, setSelectedAccount] = useState();
  const [clientFormType, setClientFormType]= useState('View');
  const [processInvoiceCollapsed, setProcessInvoiceCollapsed] = useState(true);


    useEffect(() => {
        alertClose();
        if(loggedUser.isAuthenticated){
            fetchClientDetails();  
        }else{
            validateLogin();
        }
    }, [loggedUser]);

    const fetchClientDetails=async()=>{
       // console.log("fetching clients list");
        try{
          setLoaded(false);
          const { idToken } = (await fetchAuthSession()).tokens ?? {};
          //const access_token=session.idToken.jwtToken;
          await axios.get(`${config.api.invokeURL}/admin/clients`,{
              headers: {
                Authorization: idToken,
                'x-api-key': config.api.key
              }}, 
          ).then((response)=>{
            //console.log("Response : ", response);
              setClientDetails(response.data);
              setAlertDetails({
                  ...alertDetails,
                  style:"success",
                  open:true,
                  message: response.data.length + " - Records Found"
              });  
              //console.log(response);
              setLoaded(true);
          }).catch((error)=>{
              //console.log(error);
              setAlertDetails({
                  ...alertDetails,
                  style:"warning",
                  open:true,
                  message:"Error Occured - " + error.message
              }); 
              setLoaded(true);
              //setDispMsg(error.message);
          })
        }catch(error){
          setAlertDetails({
            ...alertDetails,
            style:"warning",
            open:true,
            message:"Error Occured - " + error.message
        }); 
        setLoaded(true);
        }
    }

    const clientViewToggle=()=>{
      setClientViewCollapsed(!clientViewCollapsed);
    }

    const handleViewAccounts=async(event, item)=>{
        event.preventDefault();
        setSelectedAccount(item);
        clientViewToggle();
    }

    const handleAddAccounts=async(event, item, type)=>{
      event.preventDefault();
      setSelectedAccount(item);
      accountsAddToggle();

  }

    const orderViewToggle=()=>{
      setOrderViewCollapsed(!orderViewCollapsed);
    }

    const handleViewOrders=async(event, item)=>{
      event.preventDefault();
      setSelectedAccount(item);
      orderViewToggle();
  }

  const processOrderToggle=()=>{
    setProcessOrderCollapsed(!processOrderCollapsed);
  }

  const processInvoiceToggle=()=>{
    setProcessInvoiceCollapsed(!processInvoiceCollapsed);
  }

  const handleProcessOrders=async(event, item)=>{
    event.preventDefault();
    setSelectedAccount(item);
    processOrderToggle();
}

const clientAddToggle = () => {
  //   console.log("clicked");
       setClientAddCollapsed(!clientAddCollapsed);
   }

  const handleShowInvoice=(event, item)=>{
    event.preventDefault();
    setSelectedAccount(item);
    processInvoiceToggle();

  }

   const accountsAddToggle = () => {
    //   console.log("clicked");
         setAccountAddCollapsed(!accountAddCollapsed);
     }

const handleClientAdd=(event, type)=>{
  event.preventDefault();
  setClientFormType(type);
  clientAddToggle();
}

const handleClientForm=(event, data, type)=>{
  event.preventDefault();
  setSelectedAccount(data);
  setClientFormType(type);
  clientAddToggle();
}


    
  return (
    <> 
    <main id="main" className="main">
    <Preloader show={loaded ? false : true} />
    <Breadcrumb>
    <BreadcrumbItem>
      <Link to={RoutesLocal.Presentation.path}>
        Home
      </Link>
    </BreadcrumbItem>
    <BreadcrumbItem >
      My Clients
    </BreadcrumbItem>
  </Breadcrumb>


         {/*Clients Form*/}
         <Modal onHide={clientAddToggle} show={!clientAddCollapsed} >
                    <Modal.Header toggle={clientAddToggle}>
                      Clients - {clientFormType} Form
                    </Modal.Header>
                    <Modal.Body>    
                    <div>
                      <ClientAddForm selectedAccount={selectedAccount} clientFormType={clientFormType} fetchClientDetails={fetchClientDetails} clientAddToggle={clientAddToggle} />
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
            {' '}
            <Button onClick={clientAddToggle}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

          {/*Add Packages / Accounts*/}
          <Modal onHide={accountsAddToggle} show={!accountAddCollapsed}>
                    <Modal.Header toggle={accountsAddToggle}>
                      Clients - Add Form
                    </Modal.Header>
                    <Modal.Body>    
                    <div>
                      <AccountsAddForm selectedClient={selectedAccount} accountsAddToggle={accountsAddToggle} />
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
            {' '}
            <Button onClick={accountsAddToggle}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

          {/*View Accounts*/}
        <Modal onHide={clientViewToggle} show={!clientViewCollapsed}>
                    <Modal.Header toggle={clientViewToggle}>
                      Accounts
                    </Modal.Header>
                    <Modal.Body>    
                    <div>
                            <ClientAccountsView selectedAccount={selectedAccount}/>                        
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
            {' '}
            <Button onClick={clientViewToggle}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>
         {/*View Orders*/}
        <Modal onHide={orderViewToggle} show={!orderViewCollapsed}>
          <Modal.Header toggle={orderViewToggle}>
            Order History
          </Modal.Header>
          <Modal.Body>    
          <div>
                  <ClientOrdersView selectedAccount={selectedAccount}/>                        
            </div>
          </Modal.Body>
          <Modal.Footer>
            {' '}
            <Button onClick={orderViewToggle}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

         {/*Process Orders*/}
         <Modal onHide={processOrderToggle} show={!processOrderCollapsed} >
          <Modal.Header toggle={processOrderToggle}>
            Accounts
          </Modal.Header>
          <Modal.Body>    
          <div>
                  <ProcessOrder selectedAccount={selectedAccount}/>                        
            </div>
          </Modal.Body>
          <Modal.Footer>
            {' '}
            <Button onClick={processOrderToggle}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

         {/*Generate Invoice*/}
         <Modal onHide={processInvoiceToggle} show={!processInvoiceCollapsed} size="lg">
          <Modal.Header toggle={processInvoiceToggle}>
            Generate Invoice
          </Modal.Header>
          <Modal.Body>    
          <div>
                  <InvoicePage selectedAccount={selectedAccount}/>                        
            </div>
          </Modal.Body>
          <Modal.Footer>
            {' '}
            <Button onClick={processInvoiceToggle}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

        <Dropdown>
            <Dropdown.Toggle as={Button} onClick={(event)=>{handleClientAdd(event, "Add")}} variant="secondary" className="text-dark me-2">
            <i className="bi bi-plus me-2"></i>
            <span>New</span>
          </Dropdown.Toggle>
          </Dropdown>


        <Table responsive hover className="user-table align-items-center">
             <thead>
                <tr>
                <th>#</th>
                <th>Client ID</th>
                <th>Organisation</th>
                <th>Client Name</th>
                <th>Registered Date</th>
                <th>Action</th>
                </tr>
            </thead>
            <tbody>
            {clientDetails.map((item, index)=>
            <tr key={index}>
            <th scope="row">{index+1}</th>
            <td>{item.clientId}</td>
            <td>{item.clientOrg}</td>
            <td>{item.clientPOC}</td>
            <td>{item.clientRegisteredDate}</td>
           <td>
           <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <span className="icon icon-sm">
                <i className="bi bi-three-dots"></i>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item  onClick={(event)=>{handleShowInvoice(event, item, "Invoice")}} >
                <i className="bi bi-eye"></i> Generate Invoice {item.clientOrg}
              </Dropdown.Item>
            <Dropdown.Item  onClick={(event)=>{handleClientForm(event, item, "View")}} >
                <i className="bi bi-eye"></i> View {item.clientOrg}
              </Dropdown.Item>
              <Dropdown.Item  onClick={(event)=>{handleClientForm(event, item, "Edit")}} >
                <i className="bi bi-pen"></i> Edit {item.clientOrg}
              </Dropdown.Item>

              <Dropdown.Item  onClick={(event)=>{handleViewAccounts(event, item)}} >
              <i className="bi bi-eye"></i> View Accounts
              </Dropdown.Item>
              <Dropdown.Item  onClick={(event)=>{handleViewOrders(event, item)}} >
                <i className="bi bi-eye"></i> View Orders
              </Dropdown.Item>
              <Dropdown.Item  onClick={(event)=>{handleProcessOrders(event, item)}} >
                <i className="bi bi-pen"></i> Process Orders
              </Dropdown.Item>
              <Dropdown.Item  onClick={(event)=>{handleAddAccounts(event, item, "Add")}} >
                <i className="bi bi-plus"></i> Add Accounts
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
            </td>
            </tr>)}
            </tbody>
        </Table>
      </main>
    </>
    )
}
